import { saveAs } from 'file-saver';
import { Component, OnInit } from '@angular/core';
import { Utils } from './addtocalender.utils';
import { SlotDataService } from '../slots-data.service';
import { SharedService } from '../../shared/services/shared.service';


@Component({
  selector: 'app-addtocalender',
  templateUrl: './addtocalender.component.html',
  styleUrls: ['./addtocalender.component.css']
})
export class AddtocalenderComponent implements OnInit {

  public calendarUrl;

  public defaultData = {
      startDate: '@',
      endDate: '@',
      title: '@',
      description: '@',
      location: '@'
  }
  public isExternal;
  public externalStyle;
  public isMobileView:boolean=false;

  constructor(private utils: Utils,
    public slotDataService: SlotDataService,
    private sharedService : SharedService
  ) { }

  ngOnInit() {
    if(window.outerWidth < 768){
      this.isMobileView=true;
    }else{
      this.isMobileView=false;
    }
    this.isExternal = this.sharedService.isExternal;
    this.externalStyle = this.sharedService.externalStyle;
    if(this.externalStyle){
      this.externalStyle = JSON.parse(this.externalStyle);
    }
  }

  /**
   * Function to sanitize data
   */
  getSanitizedData() {
    let urlData = this.defaultData;
    var data = this.slotDataService.getData();
    Object
      .keys(this.defaultData)
      .forEach(key => {
        urlData[key] = encodeURIComponent(data[key] || '');
      });
    return urlData;
  }

  /**
   * Function to google calender url to add event to google calender
   */
  getGoogleCalenderUrl() {
    // var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var timezone = this.slotDataService.timezone;
    var data = this.getSanitizedData();
    var googleCalenderUrl = 'https://www.google.com/calendar/render?action=TEMPLATE';
    googleCalenderUrl += '&text=' + data.title;
    googleCalenderUrl += '&dates=' + data.startDate + '/' + data.endDate;
    googleCalenderUrl += '&ctz=' + timezone;
    googleCalenderUrl += '&details=' + data.description;
    googleCalenderUrl += '&location=' + data.location;

    return googleCalenderUrl;
  }

  /**
   * Function to get calender ics data
   * @param data 
   */
  getIcsCalender(data) {
    return [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'BEGIN:VEVENT',
      'CLASS:PUBLIC',
      'DESCRIPTION:' + this.utils.formatIcsText(data.description, 62),
      'DTSTART:' + data.startDate,
      'DTEND:' + data.endDate,
      'LOCATION:' + this.utils.formatIcsText(data.location, 64),
      'SUMMARY:' + this.utils.formatIcsText(data.title, 66),
      'TRANSP:TRANSPARENT',
      'END:VEVENT',
      'END:VCALENDAR',
      'UID:' + this.utils.getUid(),
      'DTSTAMP:' + this.utils.getTimeCreated(),
      'PRODID:appointment'
    ].join('\n');
  }

  /**
   * Function to get outlook ics file
   */
  getOutlookFile() {
    var data = this.slotDataService.getData();
    let fileName = this.utils.getIcsFileName(data.title),
      icsData = this.getIcsCalender(data),
      icsBlob = this.utils.getIcsBlob(icsData);
    saveAs(icsBlob, fileName);
  }
}



// WEBPACK FOOTER //
// ./src/app/slots/addtocalender/addtocalender.component.ts